import { Role } from "./user.types";

// Roles that have admin privileges.
export const ADMIN_ROLES = [
  Role.EntityAdmin,
  Role.OpengovAdmin,
  Role.OpengovEngineer,
  Role.OpengovSales,
  Role.OpengovTSD,
  Role.OpengovUser,
];

export const isAdmin = (role: Role) => ADMIN_ROLES.includes(role);
